import * as React from 'react';

import Button from 'components/Button';
import Container from 'components/Container';
import Image from 'components/Image';
import Link from 'components/Link';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import LinkConstants from 'constants/LinkConstants';

import OrganizationEngagementViewSection from './OrganizationEngagementViewSection';

import './OrganizationEngagementViewContentFooter.scss';

type Props = {
  city?: string;
  eventKey: string;
  greatSchoolsUrl?: string;
  name?: string;
  state?: string;
  url?: string;
  utmParams: string;
};

export default function OrganizationEngagementViewContentFooter({
  city,
  eventKey,
  greatSchoolsUrl,
  name,
  state,
  url,
  utmParams,
}: Props) {
  return (
    <OrganizationEngagementViewSection
      angle={false}
      className="OrganizationEngagementViewContentFooter">
      {greatSchoolsUrl ? (
        <Container size="large">
          <MediaObject center>
            <Image
              src={require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewContentFooter/district.png')}
              srcSet={`${require('assets/images/organizations/OrganizationEngagementView/OrganizationEngagementViewContentFooter/district@2x.png')} 2x`}
            />
            <div>
              <Row size="small">
                {name && (
                  <Text element="h2" font="serif" size="xxxlarge">
                    {name}
                  </Text>
                )}
                {city &&
                  state && (
                    <Text element="div" size="large" weight="semibold">
                      {city}, {state}
                    </Text>
                  )}
                {url && (
                  <Link
                    href={url}
                    target="_blank"
                    eventKey={`${eventKey}.content_footer.district_url.click`}>
                    <Text element="div" size="medium" weight="semibold">
                      {url}
                    </Text>
                  </Link>
                )}
              </Row>
              <Button
                href={`${greatSchoolsUrl}?${utmParams}&utm_content=footer`}
                size="medium"
                target="_blank"
                eventKey={`${eventKey}.content_footer.cta.click`}>
                See GreatSchools profile
              </Button>
            </div>
          </MediaObject>
        </Container>
      ) : (
        <Text align="center" element="div">
          <Container size="medium">
            <Row size="small">
              <Text element="h2" font="serif" size="xxxlarge">
                <span className="OrganizationEngagementView--highlight">
                  Effective engagement
                </span>{' '}
                improves student&nbsp;outcomes.
              </Text>
            </Row>
            <Text element="p" size="medium">
              Get engagement ratings, community engagement statistics, and best practices for more
              than 100,000 K-12 schools.
            </Text>
            <Button
              href={`${LinkConstants.ENGAGEMENT_RATINGS}?${utmParams}&utm_content=footer`}
              eventKey={`${eventKey}.content_footer.cta.click`}>
              Find a school
            </Button>
          </Container>
        </Text>
      )}
    </OrganizationEngagementViewSection>
  );
}
